export function scrollElementIntoView(id) {
  const widgetElement = document.getElementById(id);

  if (widgetElement) {
    widgetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  return false;
}